import { Subscription } from 'rxjs';
import { ISerializable } from './base';

export class Service implements ISerializable<Service> {
  id: string | undefined;
  name: string | undefined;
  health: ServiceRequest | undefined;
  environment: ServiceRequest | undefined;
  reload: ServiceRequest | undefined;
  routes: ServiceRequest | undefined;
  config: ServiceRequest | undefined;

  deserialize(input: any): Service {
    this.id = input.name.replace(/[-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '_').toLowerCase();
    this.name = input.name;
    this.health = new ServiceRequest().deserialize(input.health);
    if (input.environment) {
      this.environment = new ServiceRequest().deserialize(input.environment);
    }
    if (input.reload) {
      this.reload = new ServiceRequest().deserialize(input.reload);
    }
    if (input.routes) {
      this.routes = new ServiceRequest().deserialize(input.routes);
    }
    if (input.config) {
      this.config = new ServiceRequest().deserialize(input.config);
    }
    return this;
  }
}

export class ServiceRequest implements ISerializable<ServiceRequest> {
  URL: string | undefined;
  requestCallback: any | undefined;
  data: any | undefined;
  success: boolean | undefined;
  updating: boolean | undefined;
  timestamp: Date | undefined;
  updateSubscription: Subscription | undefined;
  healthy: Date | undefined;

  deserialize(input: any): ServiceRequest {
    this.URL = input.URL;
    this.requestCallback = input.requestCallback;
    return this;
  }
}

export class ConfigItem {
  key: string | undefined;
  value: string | undefined;

  static create(key: string, value: string) {
    const ci = new ConfigItem();
    ci.key = key;
    ci.value = value;
    return ci;
  }
}
